<template>

    <div class="project-table">
    
      <h2>项目管控表</h2>
    
      <HotTable
        :data="tableData"
        :colHeaders="columns"
        :rowHeaders="true"

        :width="'100%'"
        :height="600"

        :licenseKey="'non-commercial-and-evaluation'"

        :manualColumnResize="true"
        :manualRowResize="true"

        :stretchH="'none'"

        :contextMenu="true"

        :minSpareRows="1"
        :minSpareCols="1"

        :colWidths="120"
        />
    
    </div>
    
    </template>
    
    
    <script>
    
    import { HotTable } from "@handsontable/vue"
    import { registerAllModules } from "handsontable/registry"
    import "handsontable/styles/handsontable.css"
    import "handsontable/styles/ht-theme-main.css"
    registerAllModules()
    
    export default {
    
      name: "ProjectControlPage",
    
      components: {
        HotTable
      },
    
      data() {
        return {
    
          columns: [
            "国家",
            "客户名称",
            "项目名称",
            "数量",
            "取单(亿)",
            "发货(亿)",
            "国内供应商",
            "代理模式",
            "沟通进度",
            "报价通过",
            "合同签署",
            "预付款",
            "发货交单"
          ],
    
          tableData: [
            ["美国","AWC","变压器","100台","","","","","","","","",""],
            ["美国","Solar Landscape","变压器","30/年","","","","","","","","",""]
          ]
    
        }
      },
      mounted() {

document.addEventListener("paste", this.handlePaste)

},

methods:{

handlePaste(event){

  const items = event.clipboardData.items

  for (let item of items) {

    if (item.type.indexOf("image") !== -1) {

      const file = item.getAsFile()

      const reader = new FileReader()

      reader.onload = (e)=>{

        const base64 = e.target.result

        console.log(base64)

        // 写入当前单元格
        this.hotInstance.setDataAtCell(0,10,base64)

      }

      reader.readAsDataURL(file)

    }

  }

}

}
    
    }
    
    </script>
    
    
    <style>
    
    .project-table{
      padding:20px;
    }
    
    </style>